import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DescriptionIcon from '@mui/icons-material/Description'

import CardTable from 'components/CardTable/CardTable'
import { TableInputs } from 'components/CardTable/TableInputs'
import { useSearch } from 'hooks/useSearch'
import { validateObject } from 'helpers/validateObject'
import { columns } from './columns'
import {
  downloadSurvey,
  getSurveys,
  setSurveysFilters,
} from 'redux/actions/surveys/surveysAction'


export const SurveyView = () => {
  const dispatch = useDispatch()
  const { setSnackbar } = useSearch()
  const { surveys, station, startDate, endDate } = useSelector(({ surveys }) => surveys)
  const { isLoadingComp } = useSelector(({ search }) => search)

  const loading = isLoadingComp?.loadingSurveys

  const handleSubmit = useCallback((e) => {
    e?.preventDefault?.()
    if (!station?.id) return setSnackbar('Seleccione una planta', 'warning')
    if (!startDate || !endDate) return setSnackbar('Seleccione rango de fechas', 'warning')
    dispatch(getSurveys(station, startDate, endDate))
  }, [station, startDate, endDate])

  const handleDownLoad = useCallback(() => {
    dispatch(downloadSurvey(startDate, endDate, station))
  }, [startDate, endDate, station])

  return (
    <CardTable
      hasHeader
      title="Lista de encuesta"
      icon={<DescriptionIcon />}
      columns={columns}
      rowText="empleados"
      data={surveys}
      blockBtn
      hasControl
      isLoading={loading}
      tableContent={
        <TableInputs
          stations
          dates
          reducer="surveys"
          dispatchAction={setSurveysFilters}
          submitAction={handleSubmit}
          submitSecond={handleDownLoad}
          submitSecondButtonName="Excel"
          submitSecondTooltip="Descargar Excel"
          submitSecondDisabled={!validateObject(surveys)}
          loading={loading}
        />
      }
    />
  )
}
